import { Box, Tooltip, VStack } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import type { DocumentExportFragment } from "@src/__generated__/graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { format } from "date-fns";
import { lowerCase, startCase } from "lodash";
import type { FC } from "react";

type DocumentExportIndicatorProps = {
  readonly documentExports: DocumentExportFragment[];
};

const formatExportType = (type: string): string => startCase(lowerCase(type));

const formatExportedAt = (exportedAt: string): string =>
  format(new Date(exportedAt), "dd.MM.yyyy HH:mm");

export const DocumentExportIndicator: FC<DocumentExportIndicatorProps> = ({
  documentExports,
}) => {
  if (!documentExports.length) return null;

  return (
    <Tooltip
      label={
        <VStack align="start" spacing="1">
          {documentExports.map((documentExport) => (
            <Box key={`${documentExport.type}-${documentExport.exported_at}}`}>
              {`${formatExportType(documentExport.type)} - ${formatExportedAt(documentExport.exported_at)}`}
            </Box>
          ))}
        </VStack>
      }
      shouldWrapChildren
    >
      <Box ml="2" aria-label={t`Document was exported`}>
        <Icon color="grey.600" name="link-external-01" />
      </Box>
    </Tooltip>
  );
};
